<div class="notifications" [ngClass]="unreadAndActiveClass" (click)="show($event)">
  <app-icon iconName="bell"></app-icon>
  <span>{{ countText }}</span>
</div>

<app-popover #overlay appendTo="body">
  <div *ngFor="let item of notifications; trackBy: trackByIndex" class="notification--item">
    <ng-container *ngIf="isMentionAlert(item)">
      {{ item.supplemental.createdBy.first }}
      {{ item.supplemental.createdBy.last }}
      mentioned you on
      {{ item.objectType }}
      <a class="link" href="{{item.alertURL}}" (click)="overlay.hide()">{{ item.objectId }}</a>
    </ng-container>
    <ng-container *ngIf="!isMentionAlert(item) && item.objectType.toLowerCase() === 'chart download'">
      <div>
        Chart with Chart ID
        <a class="link" (click)="onDownloadChartClick($event, item, overlay)">{{ item.message }}</a>
        is ready for download.
      </div>
    </ng-container>
    <ng-container *ngIf="!isMentionAlert(item) && item.objectType.toLowerCase() !== 'chart download'">
      <div>
        <a *ngIf="item.objectId !== 0" class="link" [routerLink]="[item.alertURL]" (click)="overlay.hide()">{{
          item.objectId
          }}</a>
        {{ item.message }}
      </div>
    </ng-container>
    <div class="notification--item--timestamp">
      <span>{{ item.timeStamp }}</span>
    </div>
  </div>

  <div class="see-all--container">
    <a routerLink="/notification" (click)="overlay.hide()">See All</a>
  </div>
</app-popover>
